import { motion } from 'framer-motion';
import Lottie from 'lottie-react';
import colorfulAnimation from '../../assets/animations/dashboard-loading.json';
import styles from '@/styles/features/auth/auth-pages.module.css';

/**
 * Full-page card loader shown during auth / app initialization.
 * Displays a branded card (white card on the Mira background) with
 * the Lottie animation instead of the old SVG spinner.
 */
const CardLoader = ({ message = 'Please wait while we log you in.' }) => {
  return (
    <div
      className={`fixed inset-0 flex justify-center items-center overflow-hidden ${styles.loaderBackground}`}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.25 }}
        className="w-[470px] max-w-[calc(100vw-32px)] h-[338px] bg-white rounded-2xl shadow-[0_24px_70px_rgba(16,24,40,0.4)] flex flex-col justify-center items-center gap-2"
      >
        <img
          src="/loaninghub-icon.png"
          alt="Loaning Hub"
          className="h-12"
        />

        <div className="w-56 h-56 -mt-14 -mb-14">
          <Lottie
            animationData={colorfulAnimation}
            loop
            className={styles.fullSizeLottie}
          />
        </div>

        <p className={`p-sm-regular text-black mt-0 ${styles.brandText}`}>
          {message}
        </p>
      </motion.div>
    </div>
  );
};

export default CardLoader;
